<template>
    <b-col class="col-center block-small mb-5 px-2" :class="class_color"   lg="2" md="12"  cols="12"
           @mouseover="changebackground(false)" @mouseleave=changebackground(true)>
        <div v-if="infoBasic" class="">
            <img :src="srcImagen" alt="" class="block-small-img">
            <!-- <img :src="srcImagenCirculo" alt="" class="block-small-circulo-fondo"> -->
            <p class="mt-3 block-small-titulo" v-html="content.titulo">  </p>
        </div>
        <div  v-if="!infoBasic"  class="block-small-content-descripcion">
            <p class="mt-3 block-small-content" v-html="content.content">  </p>
        </div>
    </b-col>

</template>
<script>
    export default {
        name: 'Block',
       
        props: {
            content: Object
        },
        data: () => ({
            infoBasic : true,
             class_color: null,
        }),
        computed: {
            srcImagen() {
                let src = require('@/assets/images/commerce_internal/' + this.content.imagen)
                return src
            },
            srcImagenCirculo() {
                let src = require('@/assets/images/commerce_internal/circulo.svg')
                return src
            }
        },
        methods: {
            changebackground(value) {
                this.obj = {...this.content}
                if(this.obj){
                    if(this.obj.imagen){
                        if(value){
                            this.obj.imagen == 'bar.svg' ?  this.class_color = '':
                            this.obj.imagen == 'contrasena.svg' ?  this.class_color = '':
                            this.obj.imagen == 'nuevo-producto.svg' ?  this.class_color = '':
                            this.obj.imagen == 'instrumentos.svg' ?  this.class_color = '':
                            this.obj.imagen == 'asesoria.svg' ?  this.class_color = '':null
                        } else {
                            this.obj.imagen == 'bar.svg' ?  this.class_color = 'bg-lila':
                            this.obj.imagen == 'contrasena.svg' ?  this.class_color = 'bg-lightorange':
                            this.obj.imagen == 'nuevo-producto.svg' ?  this.class_color = 'bg-mdblue':
                            this.obj.imagen == 'instrumentos.svg' ?  this.class_color = 'bg-lightpurple':
                            this.obj.imagen == 'asesoria.svg' ?  this.class_color = 'bg-lightblue':null
                        }
                        
                    }
                }
                this.infoBasic = value
            }
        }
    }
</script>
<style scoped>
</style>